import { CharStatus } from '../../lib/statuses'
import classnames from 'classnames'

type Props = {
  value?: string
  status?: CharStatus
}

export const Cell = ({ value, status }: Props) => {
  const classes = classnames(
    'w-14 h-14 border-solid border-2 flex items-center justify-center mx-0.5 text-xl font-bold rounded dark:text-white',
    {
      'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700':
        !status,
      'border-black dark:border-slate-400': value && !status,
      'bg-slate-400 dark:bg-slate-500 text-white border-slate-400 dark:border-slate-500':
        status === 'absent',
      'bg-green-600 text-white border-green-600': status === 'correct',
      'bg-yellow-500 dark:bg-yellow-500 text-white border-yellow-500 dark:border-yellow-500':
        status === 'present',
      'cell-animation': !!value,
    }
  )

  return <div className={classes}>{value}</div>
}
